import { SongAnnotation, SongAnnotationId } from "../mp3/SongAnnotation";
import { EntitiesContainer } from "../../core/model/entity/entitiesContainer";

export const songAnnotation247_2 = [
  {
    id: "tag1-1.03",
    time: 1.032332,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-4.23",
    time: 4.22636,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-7.50",
    time: 7.501374,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-10.66",
    time: 10.664638,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag2-12.98",
    time: 12.981136,
    text: "",
    description: "",
    tags: ["tag2"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-13.18",
    time: 13.177994,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-13.40",
    time: 13.404469,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-13.60",
    time: 13.602036,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-13.85",
    time: 13.846871,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-17.00",
    time: 17.002896,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-20.24",
    time: 20.24231,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-23.43",
    time: 23.428988,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag2-25.99",
    time: 25.985538,
    text: "",
    description: "",
    tags: ["tag2"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-26.19",
    time: 26.186848,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-26.43",
    time: 26.428281,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-26.66",
    time: 26.660639,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-26.67",
    time: 26.67076,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-27.43",
    time: 27.430768,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-28.67",
    time: 28.670438,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-29.05",
    time: 29.053614,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-29.86",
    time: 29.857863,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-29.87",
    time: 29.865591,
    text: "",
    description: "",
    tags: ["tag4", "tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-30.61",
    time: 30.611575,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-30.63",
    time: 30.629253,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-32.23",
    time: 32.226284,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-32.26",
    time: 32.26181,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-33.02",
    time: 33.020959,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-33.06",
    time: 33.06464,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-33.09",
    time: 33.08809,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-34.35",
    time: 34.351634,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-34.50",
    time: 34.499108,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-35.43",
    time: 35.425002,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-36.23",
    time: 36.232698,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-36.26",
    time: 36.263589,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-37.02",
    time: 37.021389,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-37.56",
    time: 37.563844,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-38.64",
    time: 38.63611,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-39.45",
    time: 39.453623,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-39.49",
    time: 39.485981,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-40.24",
    time: 40.24258,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-41.50",
    time: 41.496696,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-41.83",
    time: 41.829774,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-42.61",
    time: 42.612057,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-42.65",
    time: 42.649344,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-43.42",
    time: 43.416525,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-43.87",
    time: 43.874072,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-44.07",
    time: 44.073997,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-44.65",
    time: 44.652947,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-45.04",
    time: 45.036061,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-45.85",
    time: 45.85414,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-45.86",
    time: 45.863186,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-46.63",
    time: 46.632751,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-47.27",
    time: 47.273528,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-47.84",
    time: 47.838363,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-48.26",
    time: 48.256851,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-49.05",
    time: 49.054189,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-49.06",
    time: 49.060327,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-49.80",
    time: 49.801398,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-50.38",
    time: 50.382593,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-51.43",
    time: 51.430217,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-52.23",
    time: 52.228675,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-53.04",
    time: 53.037832,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-55.46",
    time: 55.455288,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-58.65",
    time: 58.654781,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-61.86",
    time: 61.859446,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-65.06",
    time: 65.056722,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-68.20",
    time: 68.204255,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-71.43",
    time: 71.427644,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-74.64",
    time: 74.63935,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag2-76.97",
    time: 76.97275,
    text: "",
    description: "",
    tags: ["tag2"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-77.19",
    time: 77.19328,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag4-77.40",
    time: 77.401117,
    text: "",
    description: "",
    tags: ["tag4"],
    type: "",
    userData: {},
  },
  {
    id: "tag3-77.63",
    time: 77.626733,
    text: "",
    description: "",
    tags: ["tag3"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-77.86",
    time: 77.863095,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-81.01",
    time: 81.011372,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-84.23",
    time: 84.226445,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-87.44",
    time: 87.441948,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-90.62",
    time: 90.622266,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-93.85",
    time: 93.849809,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-97.07",
    time: 97.070824,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-100.25",
    time: 100.250873,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-103.42",
    time: 103.422191,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-106.65",
    time: 106.645229,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-109.86",
    time: 109.86344,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-113.07",
    time: 113.070984,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-116.22",
    time: 116.221444,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-119.44",
    time: 119.444432,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-122.63",
    time: 122.627564,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-125.83",
    time: 125.83141,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-129.03",
    time: 129.027209,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-132.23",
    time: 132.230623,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-135.44",
    time: 135.435265,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-138.61",
    time: 138.610712,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
  {
    id: "tag1-141.85",
    time: 141.85404,
    text: "",
    description: "",
    tags: ["tag1"],
    type: "",
    userData: {},
  },
];

export const songAnnotation247_2_entities = new EntitiesContainer<
  SongAnnotationId,
  SongAnnotation
>();

songAnnotation247_2.map((data) => {
  const entity = new SongAnnotation(data.id, data);
  songAnnotation247_2_entities.addEntity(entity);
  return entity;
});
